import OptionToggler from "../../../parts/OptionToggler";

const PressPreferences = ({
  isPressCoach,
  manualMembership,
  userToSendInformation,
}) => {
  const manualMembershipOptions = [
    { label: "On", value: true },
    { label: "Off", value: false },
  ];
  return (
    <>
      {isPressCoach && (
        <form id="form-press" method="POST" data-noreset>
          <input
            type="hidden"
            name="userToSendInformation"
            defaultValue={userToSendInformation}
          />
          <div className="row">
            <p className="mobile-hidden">Manual membership management</p>
            <div className="only-show-mobile">
              <p>Manual membership management</p>
            </div>
            <OptionToggler
              name="manualMembership"
              options={manualMembershipOptions}
              defaultValue={manualMembership}
            />
          </div>
        </form>
      )}
    </>
  );
};
export default PressPreferences;
